import { useMutation } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { buildNewExemptionFormData, INewExemption } from './newExemptionPayload';

const NewExemption = async (data: INewExemption) => {
  const formData = buildNewExemptionFormData(data);
  const response = await configApi.post(`exemption/candidate/create/`, formData);
  return response.data;
};

export const useNewExemption = () => {
  return useMutation({
    mutationFn: (data: INewExemption) => NewExemption(data),
    mutationKey: ['new_exemption'],
  });
};
